import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Logo from "@/components/common/Logo";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Menu, LayoutDashboard, LineChart } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

const ConsumerHeader = () => {
  const [isConsumer, setIsConsumer] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        supabase
          .from("consumer_profiles")
          .select("id")
          .eq("user_id", session.user.id)
          .maybeSingle()
          .then(({ data }) => {
            if (data) setIsConsumer(true);
          });
      }
    });
  }, []);
  return (
    <header className="border-b border-gray-800 bg-godyspo-background pt-[env(safe-area-inset-top)]">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="cursor-pointer"
          aria-label="Scroll to top"
        >
          <Logo className="text-[#ffd700]" disableLink={true} />
        </button>
        <nav className="hidden md:flex items-center gap-6">
          {isConsumer && (
            <Link to="/consumer/dashboard" className="text-[#ffd700] hover:text-[#e6c200] transition-colors flex items-center gap-1">
              <LayoutDashboard className="h-4 w-4" />
              Dashboard
            </Link>
          )}
          {isConsumer && (
            <Link to="/market" className="text-gray-300 hover:text-[#ffd700] transition-colors flex items-center gap-1">
              <LineChart className="h-4 w-4" />
              Market Data
            </Link>
          )}
          <Link to="/seller-net-sheet" className="text-gray-300 hover:text-[#ffd700] transition-colors">
            Seller Net Sheet
          </Link>
          <Link to="/blog" className="text-gray-300 hover:text-[#ffd700] transition-colors">
            Blog
          </Link>
          <Link to="/contact" className="text-gray-300 hover:text-[#ffd700] transition-colors">
            Contact
          </Link>
          <Link to="/consumer/login" className="text-gray-300 hover:text-[#ffd700] transition-colors">
            Sign In
          </Link>
        </nav>

        {/* Mobile Dropdown Menu */}
        <div className="md:hidden">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button className="bg-[#ffd700] text-[#080c14] hover:bg-[#e6c200]">
                <Menu className="h-5 w-5" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent 
              className="w-48 bg-[#080c14] border-gray-800 z-50"
              align="end"
            >
              {isConsumer && (
                <>
                  <DropdownMenuItem asChild>
                    <Link to="/consumer/dashboard" className="text-[#ffd700] hover:text-[#ffd700] hover:bg-gray-800 cursor-pointer">
                      Dashboard
                    </Link>
                  </DropdownMenuItem>
                  <DropdownMenuItem asChild>
                    <Link to="/market" className="text-gray-300 hover:text-[#ffd700] hover:bg-gray-800 cursor-pointer">
                      Market Data
                    </Link>
                  </DropdownMenuItem>
                  <DropdownMenuSeparator className="bg-gray-800" />
                </>
              )}
              <DropdownMenuItem asChild>
                <Link to="/valuation" className="text-[#ffd700] hover:text-[#ffd700] hover:bg-gray-800 cursor-pointer">
                  Free Valuation
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/seller-net-sheet" className="text-gray-300 hover:text-[#ffd700] hover:bg-gray-800 cursor-pointer">
                  Seller Net Sheet
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/blog" className="text-gray-300 hover:text-[#ffd700] hover:bg-gray-800 cursor-pointer">
                  Blog
                </Link>
              </DropdownMenuItem>
              <DropdownMenuSeparator className="bg-gray-800" />
              <DropdownMenuItem asChild>
                <Link to="/contact" className="text-gray-300 hover:text-[#ffd700] hover:bg-gray-800 cursor-pointer">
                  Contact
                </Link>
              </DropdownMenuItem>
              <DropdownMenuSeparator className="bg-gray-800" />
              <DropdownMenuItem asChild>
                <Link to="/consumer/login" className="text-[#ffd700] hover:text-[#ffd700] hover:bg-gray-800 cursor-pointer">
                  Sign In
                </Link>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>

        {/* Desktop Free Valuation Button */}
        <Link to="/valuation" className="hidden md:block">
          <Button className="bg-[#ffd700] text-[#080c14] hover:bg-[#e6c200]">
            Free Valuation
          </Button>
        </Link>
      </div>
    </header>
  );
};

export default ConsumerHeader;
